// api.js
export const API_BASE_URL = 'https://manager.cromoconstrutora.com.br';
